import React from "react";
import { Col, Row } from "antd";
import "./LGPDPage.scss";
import { Helmet } from "react-helmet";

class LGPDPage extends React.Component<any, any> {
    constructor(props: any) {
        super(props);

        this.getSection = this.getSection.bind(this);
        this.sectionSroll = this.sectionSroll.bind(this);
    }

    componentDidMount() {
        setTimeout(() => {
            this.getSection();
        }, 200);
    }

    componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<any>, snapshot?: any) {
        this.getSection();
    }

    /**
     * Extrai a seção da URL e faz o scroll
     */
    getSection(): void {
        let url_string = window.location.href;
        let url = new URL(url_string);

        let section = url.searchParams.get("s");
        if (section) {
            this.sectionSroll(section);
        }
    }

    /**
     * Realiza o scroll para a seção
     * @param section 'faleconosco' | 'avisoprivacidade'
     */
    sectionSroll(section: string): void {
        let yOffset = -35;
        let element = document.getElementById(section);


        let y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

        window.scrollTo({ top: y, behavior: 'smooth' });
    }

    render() {
        return (
            <div>
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>Unimake Software - LGPD</title>
                    <link rel="canonical" href={`${process.env.PUBLIC_URL}/lgpd`} />
                    <meta name="keywords" content="Unimake, Software, Unico, ERP, UniDANFE, DANFE View, UniNFe, Consult-e, UniNFSe, UniCTe, UniTransfer, Nota, Fiscal, Serviço, Eletronica, Conhecimento, Transporte, Eletronico" />
                    <meta name="description" content="A Unimake Software é uma empresa especializada no ramo de soluções para ERP, DANFE, Nota Fiscal Eletrônica (NF-e), Nota Fiscal de Serviço Eletrônica (NFS-e), Conhecimento de Transporte Eletrônico (CT-e) com os produtos Unico ERP, UniDANFE, DANFE View, UniNF-e (NF-e), Consult-e (NF-e, CT-e), UniCT-e (CT-e), UniNFS-e (NFS-e), acesse e conheça nossos produtos." />
                </Helmet>

                <section className="unimake-area-v3">
                    <div className="unimake-container">
                        <div className="lgpd-container">
                            <Row>
                                <Col sm={24} md={24}>
                                    <h1 className="ant-typography">LGPD - Lei Geral de Proteção de Dados Pessoais</h1>
                                </Col>
                            </Row>
                            <Row id="faleconosco">
                                <Col sm={24} md={24}>
                                    <h2 style={{ fontWeight: 'bold' }}>Fale conosco</h2>

                                    <br />

                                    <div>
                                        <p>
                                            Se você tiver dúvidas, sugestões ou preocupações sobre o uso de seus Dados Pessoais, entre em contato conosco, através do seguinte canal:
                                        </p>

                                        <span>e-mail: <a href="mailto:lgpd@unimake.com.br">lgpd@unimake.com.br</a> </span>

                                        <p>Sua mensagem será analisada durante o horário comercial.</p>
                                    </div>
                                </Col>
                            </Row>


                            <Row id="avisoprivacidade">
                                <Col sm={24} md={24}>
                                    <h2 style={{ fontWeight: 'bold' }}>Aviso de Privacidade</h2>

                                    <p style={{ marginTop: 10, textAlign: 'justify' }}>
                                        A proteção dos seus dados pessoais é importante para a Unimake Software!<br />
                                        <br />
                                        A Unimake Software sabe o quão importante são a segurança e a privacidade de informações dos usuários dos seus serviços, por isso, adota as medidas necessárias para protege-las.<br />
                                        <br />
                                        Este Aviso de Privacidade apresenta como coletamos, compartilhamos e utilizamos seus Dados Pessoais e como você poderá exercer seus direitos de privacidade, tornando transparente o compromisso da Unimake Software com a proteção das informações que lhe são confiadas.<br />
                                        <br />
                                        Recomendamos que você leia este Aviso de Privacidade por completo para garantir que esteja totalmente informado e compreenda os termos apresentados.
                                        <br />
                                    </p>

                                    <h3 style={{ fontWeight: 'bold' }}>1. Dados pessoais que coletamos</h3>
                                    <p style={{ marginTop: 5, textAlign: 'justify' }}>
                                        Assumimos o compromisso de coletar apenas os dados mínimos e necessários para efetivar o objetivo de entrar em contato via e-mail ou telefone para apresentar os produtos e serviços oferecidos, o que inclui informações que possam ajudar na resolução de problemas e melhoria do serviço. <br />
                                        <br />
                                        Para permitir a correta identificação dos possíveis clientes, são necessários coletar alguns dados pessoais como nome e e-mail.<br />
                                        É importante esclarecer que quando pedimos algum dado pessoal, você tem a opção de recusar. Entretanto, o fornecimento é mandatório para que possamos entrar em contato com você para enviar e-mails e materiais oferecendo nossos produtos e serviços.<br />
                                        <br />
                                    </p>

                                    <h3 style={{ fontWeight: 'bold' }}>2. Como utilizamos os seus dados</h3>
                                    <p style={{ marginTop: 5, textAlign: 'justify' }}>
                                        Os dados são coletados quando o USUÁRIO faz o cadastro no site da Unimake Software ou quando entra em contato através de um dos nossos canais de atendimento e são utilizados para efetuar contato comercial para oferta de produtos e serviços através das seguintes ações: <br />
                                        <br />
                                        <ul>
                                            <li>Envio de e-mails para oferta de produtos;</li>
                                            <li>Envio de e-mails para oferecer conteúdo exclusivo;</li>
                                        </ul>
                                    </p>

                                    <h3 style={{ fontWeight: 'bold' }}>3. Dos direitos do USUÁRIO </h3>
                                    <p style={{ marginTop: 5, textAlign: 'justify' }}>
                                        Atendendo ao disposto no artigo 18 da Lei Geral de Proteção de Dados, a Unimake Software informa que o USUÁRIO poderá exercer seus direitos de forma direta por meio do nosso contato <a href="mailto:lgpd@unimake.com.br">lgpd@unimake.com.br</a>. <br />
                                        <br />
                                        A qualquer momento o USUÁRIO poderá requerer a: <br />
                                        <br />
                                        <ul>
                                            <li>Confirmação da existência do tratamento de dados pessoais;</li>
                                            <li>Correção dos dados incompletos, inexatos ou desatualizados;</li>
                                            <li>Solicitação para que seus dados sejam anonimizados, bloqueados ou eliminados quando desnecessários, excessivos;</li>
                                            <li>Solicitação da portabilidade dos seus dados a outro prestador de serviços, mediante requisição expressa;</li>
                                            <li>Informação a respeito das entidades públicas ou privadas com as quais a Unimake Software compartilha seus dados.</li>
                                        </ul>
                                        <br />
                                        A Unimake Software está comprometida em a proteção de seus dados pessoais e obterá o seu consentimento quando for necessário. Se você revogar o consentimento, informaremos as consequências resultantes da sua vontade.<br />
                                        <br />
                                        Você também poderá solicitar a exclusão dos seus dados. Nós receberemos a solicitação e procederemos com a remoção dos dados. Mas caso exista algum motivo legal que impossibilite a exclusão, você será devidamente informado. <br />
                                        <br />
                                        Lembre-se! <br />
                                        <br />
                                        A sua solicitação deve ser feita por meio de requisição formal através do nosso contato: <a href="mailto:lgpd@unimake.com.br">lgpd@unimake.com.br</a>.<br />
                                    </p>

                                    <h3 style={{ fontWeight: 'bold' }}>5. Alterações no Aviso de Privacidade</h3>
                                    <p style={{ marginTop: 5, textAlign: 'justify' }}>
                                        Para assegurar regras claras e precisas, a Unimake Software poderá atualizar este conteúdo a qualquer momento, sem prévia autorização e com efeito imediato, buscando sempre o melhor atendimento aos interesses dos USUÁRIOS que são os titulares dos dados pessoais. Por isso, recomendamos a leitura periódica do nosso Aviso de Privacidade.<br />
                                        <br />
                                    </p>

                                    <h3 style={{ fontWeight: 'bold' }}>6. Fale conosco</h3>
                                    <p style={{ marginTop: 5, textAlign: 'justify' }}>
                                        Se você tiver dúvidas, sugestões ou preocupações sobre o uso de seus Dados Pessoais, entre em contato conosco, através do seguinte canal: <br />
                                        <br />
                                        E-mail: <a href="mailto:lgpd@unimake.com.br">lgpd@unimake.com.br</a> <br />
                                        Sua mensagem será analisada durante o horário comercial.
                                    </p>

                                </Col>
                            </Row>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

export default LGPDPage;
